<div class="loyalty-campaign-card-promo-details-container" *transloco="let t">

  @if (campaignUserStatus() == CampaignUserStatus.ACTIVE) {
    <div class="details-row">
      <img ngSrc="/assets/icons/deal-icon.svg" alt="deal icon" height="16" width="16">
        <div class="details-text-row">
          <span class="details-text" [class.light]="lightFont()">{{ activeRewardsText() }}</span>
        </div>
    </div>
  }

  @switch (campaign().additionalConditions?.additionalConditionsType) {
    @case (AdditionalConditionsType.LOYALTY) {
      <div class="details-row">
      <img ngSrc="/assets/icons/hearts-line.svg" alt="hearts line icon" height="16" width="16">
        <div class="details-text-row">
          <!-- TODO: Fix this when the new design is ready -->
          <span class="details-text" [class.light]="lightFont()">
            {{campaign().userLoyalty.loyaltyScore}}/{{campaign().additionalConditions?.value}}
          </span>
        </div>
    </div>
    }

    @case (AdditionalConditionsType.AMOUNT_SPENT) {
      <div class="details-row">
        <img ngSrc="/assets/icons/coins-icon.svg" alt="coins icon" height="16" width="16">
          <div class="details-text-row">
            <span class="details-text" [class.light]="lightFont()">
              {{ campaign().consumedBudget | loyaltyCurrency }}/{{ campaign().additionalConditions?.value | loyaltyCurrency}} {{t('actions.card.sentence.spent')}}
            </span>
          </div>
      </div>
    }

    @case (AdditionalConditionsType.NUMBER_OF_TRANSACTIONS) {
      <div class="details-row">
        <img ngSrc="/assets/icons/single-coin-icon.svg" alt="single coin icon" height="16" width="16">
          <div class="details-text-row">
            <span class="details-text" [class.light]="lightFont()">
<!--              {{t('actions.card.purchasesRatio', {purchases: campaign().userTransactionsCount, total: campaign().additionalConditions?.value})}}-->
                  {{t('actions.card.purchasesRatio', {purchases: '?', total: campaign().additionalConditions?.value})}}
            </span>
          </div>
      </div>
    }
  }

  <lib-campaign-time-conditions-details [campaign]="campaign()" [lightFont]="lightFont()"></lib-campaign-time-conditions-details>
</div>
